module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b6f3e6955d5623178c95632608fa4961.png";